import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
export const PageContentHeaderContext = /*#__PURE__*/React.createContext(null);
/** Will render its content underneath the page header/subheader. Will be sticky to page top when scrolling. */

export const PageContentHeader = _ref => {
  let {
    children
  } = _ref;
  const contentHeader = useContext(PageContentHeaderContext);
  return contentHeader ? /*#__PURE__*/createPortal(children, contentHeader) : null;
};